<template>
  <div class="search-list">
    <b-row class="search-list-filter">
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row class="search-list-table">
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="articulosTipos" 
            :fields="articulosTiposFields"
            :filter="nombre"
            :filter-function="filterByNombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarArticuloTipo">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="search-list-pagination">
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'ArticulosTiposSearchList',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    loadRubros: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      articulosTipos: [],
      articulosTiposFields: [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          label: 'Tipo de Artículo',
          sortable: true
        },
      ],

      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getArticulosTipos();
  },  
  methods: {
    getArticulosTipos() {
      this.tableBusy = true;
      this.$store.dispatch('articulosTipos/getList', this.loadRubros)
        .then(() => {
          this.articulosTipos = this.$store.getters['articulosTipos/list'];
          this.totalRegistros = this.articulosTipos.length;
          this.tableBusy = false;
        })
        .catch(error => this.showErrorMsj(error));
    },
    seleccionarArticuloTipo (item) {
      this.$emit('articuloTipoSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    },
    filterByNombre(item, filter) {
      if (!filter) return true;
      return item.nombre.toLowerCase().includes(filter.toLowerCase());
    },    
  },
}
</script>

<style>
</style>
